document.querySelectorAll('.mobile-facets__summary').forEach((elem) => {
  elem.click();
});
let clicked_once = 0;
if (document.querySelector('.custom_filter_btn')) {
  document.querySelector('.custom_filter_btn').addEventListener('click', function () {
    document.querySelector('.mobile-facets__open').click();
    clicked_once++;

    if (clicked_once > 1) {
      document.querySelectorAll('.mobile-facets__summary').forEach((elem) => {
        elem.click();
      });
    }
  });

  document.querySelector('.filter_heading_close_icon').addEventListener('click', function () {
    document.querySelector('.mobile-facets__open-wrapper').click();
  });
}

if (document.querySelector('.product__accordion')) {
  document.querySelector('.product__accordion').classList.add('first_accordion');
}

document.addEventListener('click', function (event) {
  if (event.target.closest('.generic_swatch')) {
    event.target.closest('.generic_swatch').querySelector('label').click();
  }
});

if (document.querySelector('.big_banner')) {
  const wrapper = document.createElement('div');
  wrapper.classList.add('big_banner_wrapper');

  document.querySelector('.big_banner').before(wrapper);

  document.querySelectorAll('.big_banner').forEach((banner) => {
    wrapper.appendChild(banner.cloneNode(true));
    banner.remove();
  });
}

if (document.querySelector('.click_binded_hamburger')) {
  document.querySelector('.click_binded_hamburger').addEventListener('click', function () {
    document.querySelector('.hidden_hamburger').click();

    document.querySelectorAll('.details__open').forEach((elem) => {
      elem.setAttribute('open', '');
    });
  });
}

if (document.querySelector('.wishlist-page')) {
  document.querySelector('body').classList.add('wishlist-page-body');
}

if (document.querySelector('.newsletter_popup')) {
  if (sessionStorage.getItem('newsletter_popup') === null) {
    setTimeout(() => {
      document.querySelector('.newsletter_popup').classList.add('active');
    }, 1000);
  } else {
    document.querySelector('.newsletter_popup').remove();
  }
}

if (document.querySelector('.popup_close_icon')) {
  document.querySelector('.popup_close_icon').addEventListener('click', function () {
    document.querySelector('.newsletter_popup').classList.remove('active');
    sessionStorage.setItem('newsletter_popup', 'closed');
  });
}

// Size guide selector
if (document.querySelector('#size_guide_region')) {
  document.querySelector('#size_guide_region').addEventListener('change', function () {
    const selected = this.value;
    document.querySelectorAll('.size_guide_table').forEach((guide) => {
      if (guide.classList.contains(selected)) {
        guide.classList.add('active');
      } else {
        guide.classList.remove('active');
      }
    });
  });

  document.querySelector('[data-size="cm"]').addEventListener('click', function () {
    document.querySelector('[data-size="in"]').classList.remove('active');
    this.classList.add('active');
    document.querySelector('.size_guide_modal').classList.add('cm');
    document.querySelector('.size_guide_modal').classList.remove('in');
  });
  document.querySelector('[data-size="in"]').addEventListener('click', function () {
    document.querySelector('[data-size="cm"]').classList.remove('active');
    this.classList.add('active');
    document.querySelector('.size_guide_modal').classList.add('in');
    document.querySelector('.size_guide_modal').classList.remove('cm');
  });
}

if (document.querySelector('.size_guide_modal')) {
  document.querySelector('#size_guide_opener').addEventListener('click', function () {
    document.querySelector('.size_guide_modal').classList.add('active');
  });
  document.querySelector('.size_guide_close').addEventListener('click', function () {
    document.querySelector('.size_guide_modal').classList.remove('active');
  });
}

if (document.querySelector('.big_banner_wrapper')) {
  document.addEventListener('DOMContentLoaded', function () {
    if (screen.width < 1200) {
      document.querySelectorAll('.big_banner_wrapper .big_banner').forEach((banner) => {
        gsap.to(banner, {
          scrollTrigger: {
            trigger: banner,
            start: 'top top',
            end: 'bottom top',
            pin: true,
            scrub: true,
            pinSpacing: false,
            markers: false,
          },
        });
      });
    }
  });
}

// if (document.querySelector('modal-opener')) {
//   document.querySelectorAll('modal-opener').forEach((opener) => {
//     opener.addEventListener('click', function () {
//       window.scrollBy(0, 105);
//     });
//   });
// }

// if (document.querySelector('.product__media-wrapper')) {
//   document.addEventListener('DOMContentLoaded', function () {
//     if (screen.width > 1200) {
//       let wrapper = document.querySelector('.product__media-wrapper');
//       let media = document.querySelector('.product-media-container');

//       let wrapper_height = wrapper.clientHeight;
//       let media_height = media.clientHeight;
//       let difference = wrapper_height - media_height;

//       document.querySelector('.product-description').style.marginTop = -(difference + 40) + 'px';
//     }
//   });
// }


document.addEventListener('DOMContentLoaded', function() {

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.layout-toggle');
    if (!btn) return; 

    // Only affect mobile
    if (window.innerWidth >= 750) return;

    const gridEl = document.getElementById('product-grid');
    if (!gridEl) return;

    const mode = btn.dataset.layout; 

    if (mode === 'large') {
      gridEl.classList.add('product-grid--single');
    } else {
      gridEl.classList.remove('product-grid--single');
    }

    document.querySelectorAll('.layout-toggle').forEach(el => {
      el.classList.toggle('is-active', el === btn);
    });
  });
});
